"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseValidator = void 0;
const undef_filter_1 = require("../utils/undef-filter");
class BaseValidator {
    errors = [];
    rules = [];
    get isValid() {
        return this.errors.length === 0;
    }
    addRule(rule) {
        this.rules.push(rule);
        return this;
    }
    addRules(rules) {
        rules.forEach(rule => this.addRule(rule));
        return this;
    }
    validate(value) {
        this.errors = (0, undef_filter_1.undefFilter)(this.rules.map(rule => rule(value)));
        return this.isValid;
    }
}
exports.BaseValidator = BaseValidator;
